import { memo } from "react";
import { UIMessage, useChat } from "@ai-sdk/react";
import { useQueryClient } from "react-query";

import BrainstormIdeaModal from "modules/collaboration/pages/Brainstorming/views/BrainstormIdeaModal";

import { useModalsStore } from "./modals.store";

import { getSingleBrainstormIdeaQueryKey } from "modules/collaboration/hooks/queries/useSingleBrainstormIdeaQuery";

import { BrainstormIdea } from "modules/collaboration/types/entities";

type ChatModalsProps = {
  sendMessage: ReturnType<
    typeof useChat<UIMessage<{ hidden?: boolean }>>
  >["sendMessage"];
};

const ChatModals = (props: ChatModalsProps) => {
  const { sendMessage } = props;

  const queryClient = useQueryClient();

  const { brainstormSaveDraftModal, closeModals } = useModalsStore();

  return (
    <>
      {brainstormSaveDraftModal.isOpen && (
        <BrainstormIdeaModal
          idea={brainstormSaveDraftModal.payload}
          title="Save Brainstorm Draft"
          source="chat"
          onClose={() => closeModals("brainstormSaveDraftModal")}
          onSuccess={(idea: BrainstormIdea) => {
            sendMessage({
              metadata: {
                hidden: true
              },
              text: `
User has saved a brainstorm idea draft with the following details:
ID: ${idea.id}
Title: ${idea.title}
Description: ${idea.description}

The user may have changed the details inline before saving.
The idea is now saved in the system.
This message will be hidden from the user.

Call the display_draft_brainstorm_ideas tool to render the saved draft brainstorm idea:
ID: ${idea.id}
Title: ${idea.title}
Description: ${idea.description}
and state that it has been saved successfully.

then If there are other drafts not saved yet, render them and continue the conversation with the user accordingly, otherwise state that the job is complete.
`
            });

            queryClient.refetchQueries({
              queryKey: getSingleBrainstormIdeaQueryKey(idea.id)
            });
          }}
        />
      )}
    </>
  );
};

export default memo(ChatModals);
